(ns practitest.frontend.milestone.readiness-index.subs
  (:require [practitest.frontend.components2.dashboard.chart :as-alias chart]
            [practitest.frontend.routing.router :as router]
            [practitest.frontend.milestone.readiness-index :as-alias ri]
            [practitest.frontend.milestones :as-alias milestones]
            [re-frame.core :as rf]
            [tick.core :as t]))

(def metrics
  #:metrics
  {:ccs  "Coverage Confidence"
   :ecs  "Execution Confidence"
   :rdrs "Remaining Defects Risk"})

(def metrics->tab
  #:metrics
  {:ccs  :requirements
   :ecs  :testsets
   :rdrs :issues})

(defn- score->status [score]
  (condp < score
    0.75 :status/ready
    0.50 :status/in-progress
    :status/at-risk))

(defn- url-for
  [milestone & [{:keys [tab]
                 :or   {tab :general}}]]
  (router/get-href ::milestones/edit milestone {} {:tab tab}))

(defn- prepare-metrics [milestone]
  (for [[metric label] metrics
        
        :let [score (milestone metric)
              tab   (metrics->tab metric)]]
    {:label  label
     :score  score
     :url    (url-for milestone {:tab tab})
     :status (score->status score)}))

(rf/reg-sub
 ::milestone
 (fn [[_ id] _]
   (rf/subscribe [::milestones/milestone id]))
 (fn [{:keys         [milestone_start_date milestone_end_date]
       :metrics/keys [rrqi]
       :as           milestone} _]
   (let [start-date     (js/Date. milestone_start_date)
         end-date       (js/Date. milestone_end_date)
         today          (js/Date.)
         upcoming?      (< today start-date)
         not-available? (or upcoming? (nil? rrqi))
         milestone      (cond-> milestone
                          not-available?
                          (dissoc :metrics/rrqi :metrics/ccs
                                  :metrics/ecs :metrics/rdrs))]
     (merge milestone
            {:start-date         start-date
             :end-date           end-date
             ::ri/not-available? not-available?
             ::ri/status         (if not-available?
                                   :status/not-available
                                   (score->status rrqi))
             :url                (url-for milestone)
             :metrics            (vec (prepare-metrics milestone))}))))
